import { Box, LinearProgress, Typography, Stack } from "@mui/material";
import { calculateLineupBoost } from "./utils";

/**
 * Component to display lineup boost with styled progress bar
 * @param {Object} props
 * @param {Array} props.lineup - The user's lineup used to calculate boost
 */
export default function VersusLineupBoost({ lineup }) {
  const boost = calculateLineupBoost(lineup);
  const normalizedValue = Math.min(Math.max(0, boost), 10);
  const percentage = (normalizedValue / 10) * 100;
  const getBoostColor = (percent) => {
    if (percent < 30) return "#FF4842";
    if (percent < 70) return "#FFC107";
    return "#54D62C";
  };

  return (
    <Box
      sx={{
        mt: 3,
        p: 2,
        borderRadius: 2,
        bgcolor: "background.neutral",
        boxShadow: "0 4px 12px 0 rgba(0,0,0,0.08)",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          height: "5px",
          bgcolor: getBoostColor(percentage),
        }}
      />
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        alignItems="center"
        justifyContent="space-between"
      >
        <Box>
          <Typography variant="subtitle1" sx={{ fontWeight: "bold", mb: 0.5 }}>
            Lineup Boost
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {`Current: ${normalizedValue}/10`}
          </Typography>
        </Box>
        <LinearProgress
          variant="determinate"
          value={percentage}
          sx={{
            width: { xs: "100%", sm: "50%" },
            height: 16,
            borderRadius: 2,
            bgcolor: "background.paper",
            border: "1px solid",
            borderColor: "divider",
            "& .MuiLinearProgress-bar": {
              borderRadius: 1,
              bgcolor: getBoostColor(percentage),
            },
          }}
        />
      </Stack>
    </Box>
  );
}
